export const KEYDOWN_EVENT = 'keydown';

export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
export const TAB_KEY = 'Tab';

export const CLICK_MOUSE_EVENT = 'click';
